export enum UserBalanceHistoryType {
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
  TRANSFER = 'TRANSFER',
  DISABLE_USER = 'DISABLE_USER',
  ENABLE_USER = 'ENABLE_USER',
}
